export default __webpack_public_path__ + "static/media/portfolio-78.2ed6b594.jpg";